// extracted by mini-css-extract-plugin
export default {"menus":"Menu_menus__cy5QA"};